/**
 * Zombie-upload reconciliation decision.
 *
 * Context: `tus.onError` marks the local upload as FAILED and returns
 * without notifying the backend. The backend row therefore stays in a
 * non-terminal state (CHUNK_UPLOAD_IN_PROGRESS / PENDING_CHUNKS / …) and
 * `/api/v1/upload/sessions/active` continues to return it. The user's
 * `/uploads/in-progress` page hides FAILED local cards, and the cross-
 * device dedupe suppresses the remote copy because the uploadId already
 * exists locally — net result: an invisible upload the user can't resume.
 *
 * This helper decides whether the local FAILED entry should be auto-promoted
 * back to PAUSED so the card reappears with a Resume button. Rule:
 *
 *   local.status == "FAILED"
 *   AND remote exists (backend still reporting the upload)
 *   AND remote.ownedByCurrentSession (this browser still owns it — not a
 *       genuine cross-device takeover, which is a separate flow)
 *
 * Kept pure so the reducer path can be unit-tested without mocking the
 * whole /sessions/active thunk. Backend session TTL is 3 days so we can
 * safely fire this on every poll (2s cadence).
 *
 * @param {object | null | undefined} local   the client's Redux entry for this uploadId
 * @param {object | null | undefined} remote  the /sessions/active row (may be missing)
 * @returns {boolean}                         true ⇒ dispatch PAUSED promotion
 */
export const reconcileZombieFailedToPaused = (local, remote) => {
  if (!local) return false;
  if (local.status !== "FAILED") return false;
  if (!remote) return false;
  if (!remote.ownedByCurrentSession) return false;
  return true;
};
